import { AddDestinationRequest, DestinationState, GetDestinationsResponse } from "Application/models";
import { AddNewDestinations, getCountryDestinations, getCountryDestinationsDirectClient, getNationalities } from "Application/service";
import { create } from "zustand";

export const useDestinationStore = create<DestinationState>((set) => ({
  isLoading: false,
  isError: false,
  error: null,
  destinationData: [],
  addDestionationData:[],
  nationalitiesData: [],

  getDestinations: async () => {
    set({ isLoading: true });

    try {
      const response: GetDestinationsResponse = await getCountryDestinations();

      set({isError: false, error: null, destinationData: response });

    } catch (error) {
        set({ error: 'Failed to get countries', isError: true });
        throw error;
    } finally {
      set({ isLoading: false });
    }
  },

  getDestinationsDirectClient: async () => {
    set({ isLoading: true });

    try {
      const response: GetDestinationsResponse = await getCountryDestinationsDirectClient();

      set({isError: false, error: null, destinationData: response });

    } catch (error) {
        set({ error: 'Failed to get countries', isError: true });
        throw error;
    } finally {
      set({ isLoading: false });
    }
  },

  addDestination: async (addDestionationData: AddDestinationRequest) => {
    set({ isLoading: true });

    try {
      await AddNewDestinations(addDestionationData);
      set({ isError: false, error: null });
      await useDestinationStore.getState().getDestinations(); // Refresh the list after creating a plan

    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
      set({ error: errorMessage, isError: true });
    } finally {
      set({ isLoading: false });
    }
  },

  getNationalities: async () => {
    set({ isLoading: true });

    try {
      const response = await getNationalities();
      set({ isError: false, error: null, nationalitiesData: response});

    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
      set({ error: errorMessage, isError: true });
    } finally {
      set({ isLoading: false });
    }
  },

}));